module.exports = "You're not authorized to view this page."


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-user/unauthorized/unauthorized.component.html
// module id = ../../../../../src/app/global-user/unauthorized/unauthorized.component.html
// module chunks = 2